<template>
  <v-row>
    <v-col cols="6">
      <table>
        <tr
          v-for="(item, key) in keyMap"
          :key="key"
        >
          <td
            :class="[key+1!==keyMap.length?'pb-2':'','pr-4']"
          >
            {{ item.text }}
          </td>
          <td
            :class="[key+1!==keyMap.length?'pb-2':'','font-weight-bold']"
          >
            {{ patient[item.key] || 'N&frasl;A' }}
          </td>
        </tr>
      </table>
    </v-col>
    <v-col cols="6">
      <div class="mb-3">
        <div>Allergies</div>
        <span
          v-for="(allergy, key) in patient.Allergies"
          :key="key"
        >
          {{ allergy.Allergy }} <span v-if="key != patient.Allergies.length -1">,</span>
        </span>
      </div>
      <div class="mb-3">
        <div>Medications</div>
        <span
          v-for="(medication, key) in patient.Medications"
          :key="key"
        >
          {{ medication.BrandName || medication.GenericName }} <span v-if="key != patient.Medications.length -1">,</span>
        </span>
      </div>
      <div class="mb-3">
        <div>Vices</div>
        <span
          v-for="(vice, key) in patient.Vices"
          :key="key"
        >
          {{ vice }} <span v-if="key != patient.Vices.length -1">,</span>
        </span>
      </div>
      <div class="mb-3">
        <div>Illnesses</div>
        <span
          v-for="(illness, key) in patient.Illnesses"
          :key="key"
        >
          {{ illness }} <span v-if="key != patient.Illnesses.length -1">,</span>
        </span>
      </div>
    </v-col>
  </v-row>
</template>

<script>
  export default {
    name: 'PatientDetails',

    props: {
      patient: { type: Object }
    },

    data: () => ({
      keyMap: [
        { text: 'Full Name', key: 'FullName' },
        { text: 'Birthdate', key: 'Birthdate' },
        { text: 'Gender', key: 'Gender' },
        { text: 'Civil Status', key: 'CivilStatus' },
        { text: 'Email', key: 'Email' },
        { text: 'Alternative Email', key: 'AlternativeEmail' },
        { text: 'Mobile Number', key: 'MobileNumber' },
        { text: 'Health Insurance', key: 'HealthInsurance' },
        { text: 'Height', key: 'Height' },
        { text: 'Weight', key: 'Weight' },
        { text: 'Latest Menstruation', key: 'LatestMenstruationStartDate' },
      ]
    }),

    mounted() {
      //
    }
  }
</script>

<style lang="scss" scoped>

</style>